import { makeStyles } from '@material-ui/core/styles';
import { AuthGuard, ErrorMessage, LoadingIndicator, Page, RenderGuard, CreateActivityModal } from 'components';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Slot } from 'services';
import { curriculum_manager } from "utils/constants";
import useErrorCatcher from "utils/useErrorCatcher";
import Calendar from "./components/Calendar";
import CalendarList from "./components/CalendarList";
import Toolbar from "./components/Toolbar";
import useRouter from 'utils/useRouter';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
}));

let mounted = false;

const Overview = () => {
  const [date, setDate] = useState(moment());
  const [view, setView] = useState('dayGridMonth');
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const [errorMessage, setErrorMessage] = useState("");
  const [selected, setSelected] = useState(null);
  const [openActivity, setOpenActivity] = useState(false);
  const router = useRouter();

  useEffect(() => {
  }, [date])

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);

  useEffect(() => {
    reload();
  }, [date]); //eslint-disable-line

  const reload = async () => {
    setLoading(true);
    await runAsyncBlock(async () => {
      let { models } = await Slot.list({
        query: {
          start_at: `${date.startOf("month").unix()},${date.endOf("month").unix()}`,
          end_at: `${date.startOf("month").unix()},${date.endOf("month").unix()}`,
          limit: 9999,
          sort: "start_at:asc",
          status: "scheduled,concluded",
          lesson_status: "published"
        }
      });
      if (mounted) {
        setSlots(models);
      }
    }).finally(() => { mounted && setLoading(false) });
  }

  const classes = useStyles();

  const handleViewChange = view => {
    setView(view);
  };

  const handleDateToday = () => {
    setDate(moment());
  };

  const handleDatePrev = () => {
    setDate(moment(date).subtract(1, "M"));
  };

  const handleDateNext = () => {
    setDate(moment(date).add(1, "M"));
  };

  const handleActivityOpen = (slot) => {
    setSelected(slot);
    setOpenActivity(true);
  }

  const handleActivityClose = () => {
    setSelected(null);
    setOpenActivity(false);
  }

  return (
    <AuthGuard roles={[curriculum_manager]}>
      <Page className={classes.root} title="Lesson Slots">
        <ErrorMessage message={errorMessage} />
        <Toolbar
          date={date}
          onDateNext={handleDateNext}
          onDatePrev={handleDatePrev}
          onDateToday={handleDateToday}
          onViewChange={handleViewChange}
          view={view}
        />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        <RenderGuard renderIf={view === "dayGridMonth" && !loading}>
          <Calendar handleActivityOpen={handleActivityOpen} date={date} slots={slots} />
        </RenderGuard>
        <RenderGuard renderIf={view === "list" && !loading}>
          <CalendarList date={date} slots={slots} />
        </RenderGuard>
        <CreateActivityModal onClose={handleActivityClose} onCreate={id => router.history.push(`/activities/${id}/summary`)} open={selected && openActivity} slot_id={selected} />
      </Page>
    </AuthGuard>
  );
};

Overview.propTypes = {
  className: PropTypes.string
};

export default Overview;
